import { useState } from "react";
import PageHero from "../components/PageHero";
import Lightbox from "../components/Lightbox";
import Reveal from "../components/Reveal";
import { social, feature } from "../data/site";
import lookbook from "../data/lookbook";

const items = lookbook.map((p) => ({ type: "image", src: p.src }));

export default function Gallery() {
  const [active, setActive] = useState(null);

  return (
    <>
      <PageHero
        eyebrow="The Lookbook"
        title="Worn beautifully"
        subtitle="Twelve of our finest antique gold moments — styled and photographed as they are meant to be seen, an editorial celebration of craft and grace."
        image={feature.heroGallery}
      />

      <section className="py-16 md:py-24">
        <div className="container-luxe">
          {/* Curated editorial grid */}
          <div className="grid grid-cols-2 gap-4 sm:gap-5 md:grid-cols-3 lg:grid-cols-4">
            {lookbook.map((p, i) => (
              <Reveal key={p.src} delay={(i % 4) * 80}>
                <button
                  onClick={() => setActive(i)}
                  className="group relative block w-full overflow-hidden bg-cream-dark"
                  aria-label="View photograph"
                >
                  <img
                    src={p.src}
                    alt="Culture Antique lookbook"
                    loading="lazy"
                    className="aspect-[4/5] w-full object-cover object-top transition-transform duration-[1200ms] group-hover:scale-[1.06]"
                  />
                  {/* gilt frame */}
                  <span className="pointer-events-none absolute inset-3 border border-gold/0 transition-all duration-500 group-hover:inset-2.5 group-hover:border-gold/60" />
                  {/* darken + view icon on hover */}
                  <span className="absolute inset-0 flex items-center justify-center bg-charcoal/0 transition-colors duration-500 group-hover:bg-charcoal/25">
                    <span className="flex h-11 w-11 items-center justify-center rounded-full border border-gold/80 text-gold opacity-0 transition-opacity duration-500 group-hover:opacity-100">
                      <svg viewBox="0 0 24 24" className="h-5 w-5" stroke="currentColor" strokeWidth="1.3" fill="none">
                        <path d="M12 5v14M5 12h14" />
                      </svg>
                    </span>
                  </span>
                </button>
              </Reveal>
            ))}
          </div>

          <div className="mt-16 text-center">
            <a
              href={social.instagram}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-gold"
            >
              Follow @culture_antique_jewellery
            </a>
          </div>
        </div>
      </section>

      <Lightbox items={items} index={active} onClose={() => setActive(null)} onNavigate={setActive} />
    </>
  );
}
